import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BOOKING_PATH } from 'routes';

const Dashboard = React.lazy(() => import('features/dashboard/pages/Dashboard'));

export const HomeRoute: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return <Navigate to={BOOKING_PATH} replace />;
  }

  return <Dashboard />;
};
